import SharedFooter from '@/components/share/footer'

export default {
  name: 'preview',
  components: {
    SharedFooter
  },
  computed: {
    isSignedIn () {
      return this.$store.getters.isSignedIn
    },
    env () {
      return this.$store.getters.env
    }
  },
  data () {
    return {
      smartthon: {
        awards: {},
        biz: {},
        company: {},
        coverId: '',
        grading: {},
        problem: {},
        status: {},
        suggestion: {},
        title: '',
        updateDate: ''
      },
      company: {},
      link: {
        biz: '',
        prb: '',
        tmp: ''
      },
      bizCard: {
        min: true,
        expand: false
      },
      bizButton: {
        show: true,
        none: false
      },
      isShow: false,
      loading: true,
      avatar: ''
    }
  },
  mounted () {
    let pathParams = {
      smartthonId: this.$route.params.smartthonId
    }

    let additionalParams = {
      queryParams: {
        enterpriseId: this.$route.params.enterpriseId,
        type: 'preview'
      }
    }

    this.$apig.get(this.$store.getters.api.SMARTTHON, pathParams, additionalParams, {}, !this.isSignedIn)
      .then(response => {
        this.smartthon = response.data
        this.smartthon.cover = `${process.env.S3}/smartthon/${this.$route.params.smartthonId}/cover/${this.smartthon.coverId}.png`
        this.link = {
          biz: `${process.env.S3}/smartthon/${this.$route.params.smartthonId}/biz/${this.smartthon.biz.attachmentName}`,
          prb: `${process.env.S3}/smartthon/${this.$route.params.smartthonId}/problem/${this.smartthon.problem.attachmentName}`,
          tmp: `${process.env.S3}/smartthon/${this.$route.params.smartthonId}/template/${this.smartthon.suggestion.attachmentName}`
        }
        this.avatar = `${process.env.S3}/enterprise/avatar/${response.data.company.avatarId}.png`

        window.scrollTo(0, 0)
        this.loading = false
      })
      .catch(err => {
        console.log(err)
      })
  },
  methods: {
    collapse () {
      let isShow = !this.isShow
      this.bizCard.min = !isShow
      this.bizCard.expand = isShow
      this.bizButton.show = !isShow
      this.bizButton.none = isShow
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/preview/preview.js